import SHWEBComment from './src/web.vue';


/**
 * web端评论组件
 */

/* istanbul ignore next */
SHWEBComment.install = function(Vue) {
  Vue.component('sh-web-comment', SHWEBComment);
};
export default SHWEBComment;


// WEBPACK FOOTER //
// ./src/components/base/view/interact/cmps/comment/web/index.js